import { Root as ButtonRoot } from '../Button/styles';
import { css } from '@linaria/core';
import { Root as ContextMenuRoot, ContextContainer as ContextMenuContextContainer, ListWrapper as ContextMenuListWrapper, } from '../ContextMenu/styles';
export const Root = {
    base: css `
		.${ContextMenuRoot.base} {
			> div {
				> .${ButtonRoot.base} {
					z-index: var(--global-z-index-dropdown);
				}
			}
		}

		.${ContextMenuContextContainer.base} {
			outline: none;

			.${ContextMenuListWrapper.base} {
				background: rgb(var(--dropdown-color-background));
			}
		}
	`,
    isFullwidth: css `
		&& {
			width: 100%;
			.${ButtonRoot.base} {
				width: 100%;
				text-align: left;
			}
			.${ContextMenuContextContainer.base} {
				ul {
					box-shadow: none;
				}
			}
			.${ContextMenuContextContainer.hasPaddingBottom} {
				ul {
					&:after {
						background: linear-gradient(transparent, rgb(var(--dropdown-color-background)));
					}
				}
			}
		}
	`,
};
